// Product layout switcher (2 per row, 4 per row, list) for collection pages.
// Applies the layout with inline styles straight on #product-grid (collection pages) and the All products grid on the brands page,
// so it works without any stylesheet support, and re-applies after the grid is
// re-rendered by filters or sorting.
(function () {
  if (window.__fwpProductLayout) return;
  window.__fwpProductLayout = true;

  var KEY = 'fwp-product-layout';
  var LAYOUTS = ['2', '4', 'list'];
  var layout = '4';
  try {
    var saved = window.localStorage.getItem(KEY);
    if (LAYOUTS.indexOf(saved) !== -1) layout = saved;
  } catch (e) {}

  function columns() {
    if (layout === 'list') return 'minmax(0, 1fr)';
    if (layout === '2') return 'repeat(2, minmax(0, 1fr))';
    return window.matchMedia('(min-width: 1024px)').matches ? 'repeat(4, minmax(0, 1fr))' : 'repeat(2, minmax(0, 1fr))';
  }

  function styleCard(article) {
    var list = layout === 'list';
    var first = article.firstElementChild;
    var info = first ? first.nextElementSibling : null;
    article.style.flexDirection = list ? 'row' : '';
    article.style.alignItems = list ? 'center' : '';
    article.style.gap = list ? '1.25rem' : '';
    article.style.padding = list ? '0.75rem' : '';
    article.style.borderRadius = list ? '1rem' : '';
    article.style.background = list ? '#fff' : '';
    article.style.boxShadow = list ? '0 12px 32px -14px rgba(10,46,92,0.28), 0 0 0 1px rgba(10,46,92,0.05)' : '';
    if (first) {
      first.style.width = list ? 'clamp(7rem, 28%, 13rem)' : '';
      first.style.flexShrink = list ? '0' : '';
    }
    if (info && info.tagName !== 'A') {
      info.style.flex = list ? '1 1 auto' : '';
      info.style.minWidth = list ? '0' : '';
      var title = info.querySelector('h3');
      if (title) {
        title.style.fontSize = list ? (window.matchMedia('(min-width: 768px)').matches ? '1.25rem' : '1.0625rem') : '';
        title.style.fontWeight = list ? '600' : '';
        title.style.color = list ? '#0A2E5C' : '';
      }
    }
  }

  function apply() {
    document.documentElement.setAttribute('data-product-layout', layout);
    document.querySelectorAll('#product-grid, [data-all-products-grid]').forEach(function (grid) {
    {
      grid.style.gridTemplateColumns = columns();
      grid.style.rowGap = layout === 'list' ? '1rem' : '';
      grid.querySelectorAll(':scope > li article').forEach(styleCard);
    }});
    document.querySelectorAll('[data-product-layout-switcher] [data-layout]').forEach(function (button) {
      var pressed = String(button.getAttribute('data-layout') === layout);
      if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var button = target && target.closest ? target.closest('[data-product-layout-switcher] [data-layout]') : null;
    if (!button) return;
    event.preventDefault();
    layout = button.getAttribute('data-layout');
    try { window.localStorage.setItem(KEY, layout); } catch (e) {}
    apply();
  }, true);

  window.addEventListener('resize', apply);
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();
